// Обновленный CabinetChildrenCard.js с использованием API
import React, { useState, useEffect } from 'react';
import { Card, Table, Nav, Button, Badge, Collapse } from 'react-bootstrap';
import { childrenApi } from './api/childrenApi';
import { downloadFile } from '../../../../services/apiClient';
import './CabinetChildrenCard.css';
import { statuses_types, state_child } from './data/statuses'

import expand_icon_up from '../../../../img/arrow-up-fill.svg';
import expand_icon_down from '../../../../img/arrow-down-fill.svg';

const CabinetChildrenCard = ({ data }) => {
  const [activeTab, setActiveTab] = useState('history');
  const [kgDetailsExpanded, setKgDetailsExpanded] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [attendsInfo, setAttendsInfo] = useState([]);
  const [billingInfo, setBillingInfo] = useState([]);
  const [paymentsInfo, setPaymentsInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  const { child, kg, isInKindergarten } = data;
  const { _id, firstName, lastName, birthDate, birthCertificate, statuses } = child;
  const currentKg = kg[0]; // Берем первый садик (текущий)


  useEffect(() => {
    if (currentKg) {
      loadAdditionalData();
    }
  }, [currentKg]);

  const loadAdditionalData = async () => {
    if (!currentKg) return;
    
    setLoading(true);
    try {
      const [programsData, attendsData, billingData, paymentsData] = await Promise.all([
        childrenApi.getKindergartenPrograms(currentKg._id),
        childrenApi.getAttendsInfo(_id),
        //childrenApi.getBillingInfo(_id, currentKg._id),
        //childrenApi.getPaymentsInfo(_id, currentKg._id)
      ]);

      setPrograms(programsData);
      setAttendsInfo(attendsData);
      //setBillingInfo(billingData);
      //setPaymentsInfo(paymentsData);
    } catch (error) {
      console.error('Error loading additional data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = () => !isInKindergarten ? <Badge className="status-expelled">Дитина відрахована</Badge>
    : <Badge className="status-selected">В садочку</Badge>;


  const getGroupInfo = () => {
    if (!currentKg || !currentKg.groups) return '';
    const group = currentKg.groups;
    return `Група ${group.number} ${group.name}, ${group.type}`;
  };

  const handleDownloadInvoice = async () => {
    if (!currentKg) return;
    
    try {
      await childrenApi.downloadInvoice(_id, currentKg._id);
    } catch (error) {
      alert(error.message);
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const renderTabContent = () => {
    if (loading) {
      return <div className="tab-loading">Завантаження...</div>;
    }

    switch (activeTab) {
      case 'history':
        return renderHistoryTable();
      case 'billing':
        return renderBillingTable();
      case 'attendance':
        return renderAttendanceTable();
      case 'payments':
        return renderPaymentsTable();
      default:
        return renderHistoryTable();
    }
  };

  const renderHistoryTable = () => (
    <Table responsive>
      <thead>
        <tr>
          <th>№</th>
          <th>Дата</th>
          <th>Подія</th>
          <th>Сад</th>
          <th>Група</th>
          <th>Тип</th>
          <th>Район</th>
        </tr>
      </thead>
      <tbody>
        {statuses.map((status, index) => {

            const st_translate = status.action ? 
                (statuses_types.find(st=>st.action == status.action)?.translate || status.action)
                :
                (state_child[status.state]) || status.state
            
            return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{new Date(status.statusInsertDate).toLocaleDateString('uk-UA')}</td>
            <td className={status.state === 'expelled' ? 'reject' : ''}>
              {st_translate}
            </td>
            <td>№{currentKg?.number}</td>
            <td>{getGroupInfo()}</td>
            <td>{currentKg?.groups?.type}</td>
            <td>{currentKg?.contacts?.address?.district}</td>
          </tr>
        )})}
      </tbody>
    </Table>
  );

  const renderBillingTable = () => (
    <Table responsive>
      <thead>
        <tr>
          <th>Дата</th>
          <th>Сума</th>
          <th>Тип нарахування</th>
          <th>Опис</th>
        </tr>
      </thead>
      <tbody>
        {billingInfo.map((bill, index) => (
          <tr key={index}>
            <td>{new Date(bill.date).toLocaleDateString('uk-UA')}</td>
            <td>{bill.amount} грн.</td>
            <td>{bill.type}</td>
            <td>{bill.description}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  const renderAttendanceTable = () => (
    <Table responsive>
      <thead>
        <tr>
          <th>Дата</th>
          <th>Статус</th>
          <th>Години</th>
        </tr>
      </thead>
      <tbody>
        {attendsInfo.map((attend, index) => (
          <tr key={index}>
            <td>{new Date(attend.date).toLocaleDateString('uk-UA')}</td>
            <td>{attend.status}</td>
            <td>{attend.hours}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  const renderPaymentsTable = () => (
    <Table responsive>
      <thead>
        <tr>
          <th>Дата</th>
          <th>Сума</th>
          <th>Спосіб оплати</th>
          <th>Статус</th>
        </tr>
      </thead>
      <tbody>
        {paymentsInfo.map((payment, index) => (
          <tr key={index}>
            <td>{new Date(payment.date).toLocaleDateString('uk-UA')}</td>
            <td>{payment.amount} грн.</td>
            <td>{payment.method}</td>
            <td>{payment.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  if (!currentKg) {
    return (
      <Card className="application-card">
        <div className="card-header">
          <div className="applicant-info">
            <h3 className="applicant-name">{firstName}</h3>
            <Badge className="status-expelled">Немає даних про садочок</Badge>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card className="application-card">
      <div className="card-header">
        <div className="applicant-info">
          <h3 className="applicant-name">{firstName}</h3>
          {getStatusBadge()}
        </div>
        {false && <div className="application-meta">
          <a href="#" className="regulate-btn">Редагувати</a>
        </div>}
      </div>

      <Card.Body>
        {/* Детали садика - раскрывающаяся секция */}
        <div className="birth-certificate-wrapper">
          <div className="birth-certificate">
            <div 
              className="certificate-info"
              onClick={() => setKgDetailsExpanded(!kgDetailsExpanded)}
              style={{ cursor: 'pointer' }}
            >
              <div className="children certificate-details">
                <span className="certificate-text">Заклад дошкільної освіти {currentKg.number} </span>
                <span className="certificate-date">{getGroupInfo()}</span>
              </div>
              <img 
                src={kgDetailsExpanded ? expand_icon_up : expand_icon_down} 
                alt="expand" 
                className="expand-icon" 
              />
            </div>
          </div>
        </div>

        <Collapse in={kgDetailsExpanded}>
          <div className="kg-details-expanded">
            {/* Основная информация о садике */}
            <div className="kg-basic-info">
              <div><strong>Назва:</strong> {currentKg.name}</div>
              <div><strong>Адреса:</strong> {currentKg.contacts?.address?.string}</div>
              <div><strong>Група:</strong> {getGroupInfo()}</div>
              {currentKg.groups?.children?.placeType && (
                <div><strong>Тип місця:</strong> {currentKg.groups.children.placeType}</div>
              )}
              {currentKg.groups?.children?.typeKitchen === 'diet' && (
                <div><strong>Дієтичне харчування</strong></div>
              )}
              {currentKg.groups?.specifics && (
                <div><strong>Тип групи:</strong> {currentKg.groups.specifics}</div>
              )}
              {currentKg.groups?.educators && currentKg.groups.educators.length > 0 && (
                <div><strong>Вихователі:</strong> {currentKg.groups.educators.map(el => el.firstName).join(', ')}</div>
              )}
            </div>

            {/* Контакты садика */}
            <div className="kg-contacts-section">
              <h5>Контакти садочка</h5>
              <div className="kg-contacts">
                {currentKg.contacts?.phones && <div><strong>Телефон:</strong> {currentKg.contacts.phones.join(", ")}</div>}
                {currentKg.contacts?.email && <div><strong>Email:</strong> {currentKg.contacts.email}</div>}
                {currentKg.head?.firstName && <div><strong>Директор:</strong> {currentKg.head.firstName}</div>}
              </div>
            </div>

            {/* Образовательные и парциальные программы */}
            <div className="kg-programs-section">
              <h5>Освітні та парціальні програми</h5>
              {programs.length > 0 ? (
                <Table responsive className="programs-table">
                  <thead>
                    <tr>
                      <th>Назва файлу</th>
                      <th>Розмір</th>
                      <th>Тип</th>
                      <th>Дії</th>
                    </tr>
                  </thead>
                  <tbody>
                    {programs.map((program, index) => {

                      return program.files.map((file, index_file) =>
                      
                      (
                      <tr key={index}>
                        <td>{program.name} {index_file + 1}</td>
                        <td>{formatFileSize(file.length)}</td>
                        <td>{program.type}</td>
                        <td>
                          <Button 
                            variant="outline-primary" 
                            size="sm"
                            onClick={() => downloadFile(`docfile?doc_id=${program._id}&file_id=${file._id}`, file.name)}
                          >
                            Завантажити
                          </Button>
                        </td>
                      </tr>
                    ))})}
                  </tbody>
                </Table>
              ) : (
                <div className="no-programs">Немає доступних програм</div>
              )}
            </div>
          </div>
        </Collapse>

        {/* Информация о карте киянина */}
        <div className="registration-info">
          {child.statusMR.result ? 
            <span className="registration-text">Картка киянина підтверджена</span> :
            <span className="registration-text">Картка киянина непідтверджена</span>
            }
          <span className="certificate-date">
            {child.kyivCardVerifiedDate ? new Date(child.kyivCardVerifiedDate).toLocaleDateString('uk-UA') : '22.05.2024'}
          </span>
          <span className="dot-separator">•</span>
          {false && <a href="#" className="update-data-link">Оновити дані</a>}
        </div>

        {/* Табы с информацией */}
        <div className="child-card-body">
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'history'} 
                onClick={() => setActiveTab('history')}
              >
                Історія
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'billing'} 
                onClick={() => setActiveTab('billing')}
              >
                Нарахування
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'attendance'} 
                onClick={() => setActiveTab('attendance')}
              >
                Відвідування
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                active={activeTab === 'payments'} 
                onClick={() => setActiveTab('payments')}
              >
                Оплати
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <div className="tab-content">
            {renderTabContent()}
          </div>
        </div>
      </Card.Body>

      {/* Футер карточки */}
      <div className={`child-card-footer ${!isInKindergarten ? 'child-card-footer-actions' : ''}`}>
        {!isInKindergarten ? (
          <>
            <Button variant="primary">Запис до школи</Button>
            
          </>
        ) : (
          <a href="#" className="btn btn-link" onClick={handleDownloadInvoice}>
            Завантажити рахунок для сплати послуг харчування
          </a>
        )}
      </div>
    </Card>
  );
};

export default CabinetChildrenCard;